import { Spin } from 'antd';

import layout from '@/app/styles/AppLayout.module.css';

export function StartupScreen() {
  return (
    <Spin
      spinning
      size="large"
      classNames={{
        root: layout.fullScreen,
        container: layout.fullScreenContainer,
      }}
    >
      <div className={layout.app} />
    </Spin>
  );
}
